import { render, staticRenderFns } from "./DocumentManager.vue?vue&type=template&id=09d27e23&"
import script from "./DocumentManager.vue?vue&type=script&lang=js&"
export * from "./DocumentManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports